import { statistics } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20stadium%20lights%20and%20energy%2C%20abstract%20motion%20blur%20of%20athletes%20in%20action%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20lighting%20with%20atmospheric%20haze%2C%20epic%20scale%2C%20professional%20sports%20photography%20style%20with%20lens%20flare%20and%20stadium%20crowd%20silhouettes%2C%20dark%20dramatic%20background&width=1800&height=900&seq=hero-bg-jiuzhou&orientation=landscape"
          alt="九州体育 - 全场景体育服务平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-[900px] mx-auto">
          <p className="text-primary-300 text-sm md:text-base font-medium tracking-widest uppercase mb-4 animate-fadeIn">
            全场景体育服务平台
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6 animate-slideUp">
            加入<strong className="text-primary-400">九州体育</strong>
            <br />
            感受竞技热血与运动激情
          </h1>
          <p className="text-background-200 text-base md:text-lg max-w-[650px] mx-auto leading-relaxed mb-8 animate-fadeIn">
            涵盖体育赛事直播、体育资讯、体育竞猜及运动健康等全场景服务，
            九州体育致力于为每一位体育爱好者提供极致体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slideUp">
            <a
              href="#"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即注册会员
            </a>
            <a
              href="#"
              className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-200/50 text-background-50 rounded-lg text-base font-semibold hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              下载九州体育App
            </a>
          </div>

          <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 animate-fadeIn">
            {statistics.map((stat) => (
              <div key={stat.label} className="bg-background-50/10 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-background-50/10">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-300">{stat.value}</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn { animation: fadeIn 0.8s ease-out forwards; }
        .animate-slideUp { animation: slideUp 0.8s ease-out 0.2s forwards; opacity: 0; }
      `}</style>
    </section>
  );
}